import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import LoginRequest from "../layouts/LoginReguest";
import { tokenValidation } from "../store/actions/AuthActions";
export const ProtectedRoute = ({ component: Component, ...rest }) => {
  const auth = useSelector((state) => state.auth.session);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(tokenValidation());
  });
  return (
    <Route
      {...rest}
      render={(props) => {
        if (auth) {
          return <Component {...props} />;
        } else {
          return <LoginRequest />;
        }
      }}
    />
  );
};
